import { Button, Input, Typography } from '@smartgift/frontend-toolkit';
import qs from 'qs';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { MAX_EMAIL_LENGTH } from '@hero/constants';
import { useInput } from '@hero/hooks';
import { ROUTE_PATHS } from '@hero/routes';
import { useResendAuthEmail } from '@hero/services/organization-service/hooks';
import { useNotification } from '@hero/store/hooks';
import { cleanObjectEmptyFields, isEmailValid, isEnter } from '@hero/utils';

import * as S from './style';

export const SignInEmailForm = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { showInfo } = useNotification();
  const [searchParams] = useSearchParams();

  const { value, inputProps } = useInput('');

  const [error, setError] = useState(null);

  const { mutateAsync: sendAuthMutateAsync, isLoading: sendAuthLoading } = useResendAuthEmail({
    onSuccess: () => {
      showInfo({
        message: t('yourCodeHasBeenSent', { contactInfo: value }),
        type: 'toast'
      });

      const queryString = qs.stringify(
        cleanObjectEmptyFields({
          ...searchParams,
          email: value
        }),
        { addQueryPrefix: true }
      );
      navigate(`${ROUTE_PATHS.VALIDATE}${queryString}`);
    },
    onError: () => {
      setError(true);
    }
  });

  const sendAuthHandler = async () => {
    try {
      await sendAuthMutateAsync(value);
    } catch (error) {
      setError(error);
    }
  };

  return (
    <S.SignInEmailContent>
      <Typography style={{ textAlign: 'center' }} variant="subtitle3Bold">
        {t('welcomeToMerchant')}
      </Typography>
      <S.SignInContentBody>
        <Typography style={{ textAlign: 'center' }} variant="body1">
          {t('yourGiftingJourneyBeginsHere')}
        </Typography>
        <S.SignInCard>
          <Input
            value={value}
            inputProps={{
              ...inputProps,
              maxLength: MAX_EMAIL_LENGTH,
              onChange: e => {
                inputProps.onChange(e);
                setError(false);
              }
            }}
            error={error}
            placeholder={t('email')}
            name="email"
            type="email"
            onKeyUp={e => {
              if (isEmailValid(value) && isEnter(e)) sendAuthHandler();
            }}
            helperText={error && t('emailNotFound')}
            helperProps={{
              lineClamp: 3
            }}
          />
          <Button
            color="primary"
            block
            uppercase
            disabled={!isEmailValid(value) || sendAuthLoading}
            onClick={sendAuthHandler}
          >
            {t('signIn')}
          </Button>
          <Typography variant="body2" color="fg" emphasis="weak">
            {t('emailYouMagicCodeForLogin', { type: t('signIn') })}
          </Typography>
        </S.SignInCard>
      </S.SignInContentBody>
    </S.SignInEmailContent>
  );
};
